import React from 'react';
import { Box, IconButton, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Bookmark as BookmarkIcon, BookmarkBorder as BookmarkBorderIcon } from '@mui/icons-material';
import { SINGLE_SELECT_TOGGLE_SX } from '../sections.style';

interface SelectFieldRendererProps {
  value?: string;
  addToActionItems?: boolean;
  onChange: (value: string, addToActionItems: boolean) => void;
  fieldName: string;
  options: string[]; // Options for the select
  showBookmark?: boolean;
}

export const SelectFieldRenderer: React.FC<SelectFieldRendererProps> = ({
  value,
  addToActionItems,
  onChange,
  fieldName,
  options,
  showBookmark = true,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <ToggleButtonGroup
        value={value || ''}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) {
            onChange(newValue, addToActionItems || false);
          }
        }}
        aria-label={fieldName}
        size='small'
        sx={SINGLE_SELECT_TOGGLE_SX}
      >
        {options.map(option => (
          <ToggleButton key={option} value={option}>
            {option}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      {showBookmark && (
        <IconButton size='small' onClick={() => onChange(value || '', !addToActionItems)}>
          {addToActionItems ? <BookmarkIcon color='primary' /> : <BookmarkBorderIcon sx={{ color: 'text.disabled' }} />}
        </IconButton>
      )}
    </Box>
  );
};
